import { useMemo } from 'react'
import { AxisOptions, Chart } from 'react-charts'

import s from './Graph.module.css'

type Props = {
  yAxisLabel?: string
  dataPoints?: {
    label: string
    data: {
      date: string
      value: number
    }[]
  }[]
}

const Graph = ({ yAxisLabel, dataPoints = [] }: Props) => {
  const primaryAxis = useMemo(
    (): AxisOptions<{
      date: string
    }> => ({
      getValue: ({ date }) => {
        return date
      },
      elementType: 'line',
      showDatumElements: true,
    }),
    []
  )

  const secondaryAxes = useMemo(
    (): AxisOptions<{
      value: number
    }>[] => [
      {
        getValue: ({ value }) => value,
        elementType: 'line',
        showDatumElements: true,
      },
    ],
    []
  )

  return (
    <div className={s.wrapper}>
      <div className={s.yAxisLabel}>{yAxisLabel}</div>
      <div className={s.chartWrapper}>
        <Chart
          style={{
            font: 'var(--copy-l-regular)',
          }}
          options={{
            data: dataPoints,
            primaryAxis,
            secondaryAxes,
            defaultColors: ['var(--color-purple-300)', 'var(--color-cyan-300)'],
            primaryCursor: false,
            secondaryCursor: false,
          }}
        />
      </div>
    </div>
  )
}

export default Graph
